import styles from "./ContactButton.module.css";
import { useNavigate } from "react-router-dom";

const ContactButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/contact");
  };

  return (
    <button type="button" className={styles.button} onClick={handleClick}>
      <span className={styles.buttonText}>Let's Talk</span>
    </button>
  );
};

export default ContactButton;
